const Medium = () => (
    <svg
        width='26'
        height='21'
        viewBox='0 0 26 21'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M25.6389 2.88889C25.6389 2.88889 24.5556 2.88889 24.5556 3.97222V16.25C24.5556 16.25 24.5556 17.3333 25.6389 17.3333H26V20.2222H17.3333V17.3333H18.7778V3.9H18.6333L14.2061 20.2222H10.309L5.92222 3.9H5.77778V17.3333H7.22222V20.2222H0V17.3333H0.361111C0.361111 17.3333 1.44444 17.3333 1.44444 16.25V3.97222C1.44444 3.97222 1.44444 2.88889 0.361111 2.88889H0V0H9.58244L12.9437 12.5089H13.0549L16.4464 0H26V2.88889H25.6389Z'
            fill='white'
        />
    </svg>
);

export default Medium;
